import axios from "axios";

export class UtilsService {
  async getTodayAndAfter7Days(): Promise<{
    startDate: Date;
    endDate: Date;
  }> {
    const startDate = new Date();
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 8);
    return { startDate, endDate };
  }

  async getTodayAndAfter1Month(): Promise<{
    startDate: Date;
    endDate: Date;
  }> {
    const startDate = new Date();
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + 1);
    return { startDate, endDate };
  }

  async getDateAndAfter1Day(year: number, month: number, date: number) {
    const startDate = new Date();
    startDate.setFullYear(year, month - 1, date);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 1);
    return { startDate, endDate };
  }

  async getExtendTime(time: Date, extendMinute: number) {
    const extendTime = new Date(time);
    extendTime.setMinutes(extendTime.getMinutes() + extendMinute);
    // const result = extendTime.toISOString();
    return extendTime;
  }

  async getEndTime() {
    const time = new Date();
    time.setSeconds(0, 0);
    return time.toISOString();
  }

  async getRsvEndTime(endTime: Date, extendTime: number): Promise<Date> {
    const rsvEndTime = new Date(endTime);
    rsvEndTime.setMinutes(rsvEndTime.getMinutes() - extendTime);
    return rsvEndTime;
  }

  async transISOToStringForZero(isoDate: string) {
    const date = new Date(isoDate);
    date.setSeconds(0, 0);
    return date.toISOString();
  }

  async transISOToFormatDatetime(date: Date) {
    let hour = date.getHours();
    if (hour == 0) {
      hour = 12;
    } else if (hour >= 13) {
      hour = hour % 12;
    }
    const ampm = date.getHours() >= 12 ? "오후" : "오전";
    const min = date.getMinutes().toString().padStart(2, "0");
    const result = `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${ampm} ${hour}시 ${min}분`;
    return result;
  }

  async transISOToAlimtalkFormatInKorean(date: Date) {
    let hour = date.getHours();
    if (hour == 0) {
      hour = 12;
    } else if (hour >= 13) {
      hour = hour % 12;
    }
    const ampm = date.getHours() >= 12 ? "오후" : "오전";
    const min = date.getMinutes().toString().padStart(2, "0");
    const result = `${date.getFullYear()}.${(date.getMonth() + 1).toString().padStart(2, "0")}.${date
      .getDate()
      .toString()
      .padStart(2, "0")} ${ampm} ${hour}:${min}`;
    return result;
  }

  async transISOToAlimtalkFormatInEnglish(date: Date) {
    let hour = date.getHours();
    if (hour == 0) {
      hour = 12;
    } else if (hour >= 13) {
      hour = hour % 12;
    }
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    const min = date.getMinutes().toString().padStart(2, "0");
    const result = `${date.getFullYear()}.${(date.getMonth() + 1).toString().padStart(2, "0")}.${date
      .getDate()
      .toString()
      .padStart(2, "0")} ${ampm} ${hour}:${min}`;
    return result;
  }

  async transDateToStringFormat(date: Date) {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    } else {
      return null;
    }
  }

  async transFormatByHHMM(date: Date) {
    if (date) {
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");

      return `${hours}:${minutes}`;
    } else {
      return null;
    }
  }

  async transFormatByYYYYMMDD(date: Date) {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return null;
    }
  }

  async transISOToFormatTime(date: Date) {
    let hour = date.getHours();
    if (hour == 0) {
      hour = 12;
    } else if (hour >= 13) {
      hour = hour % 12;
    }
    const ampm = date.getHours() >= 12 ? "오후" : "오전";
    const min = date.getMinutes().toString().padStart(2, "0");
    return `${ampm} ${hour}시 ${min}분`;
  }

  async transTimeFormatByHHMMSS(date: Date) {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  async createRandomString(length: number) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    return result;
  }

  async getWeekdaysBetweenDates(start: Date, end: Date): Promise<string> {
    const weekdays = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
    const days = new Set();
    const currentDate = new Date(start);
    currentDate.setHours(0, 0, 0, 0);
    const endDate = new Date(end);
    endDate.setHours(0, 0, 0, 0);
    while (currentDate <= endDate) {
      const dayOfWeek = weekdays[currentDate.getDay()];
      days.add(dayOfWeek);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return Array.from(days).join(",");
  }

  async getTimeDifferenceInMinutes(start: Date, end: Date) {
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    const timeDifferenceInSeconds = Math.ceil((endTime - startTime) / 1000);
    const timeDifferenceInMinutes = Math.ceil(timeDifferenceInSeconds / 60);
    return timeDifferenceInMinutes;
  }

  async isToday(date: Date) {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  async get6WeekRangeInMonth(start: Date) {
    const firstDayOfMonth = new Date(start);
    const weekStart = new Date(firstDayOfMonth);
    weekStart.setDate(weekStart.getDate() - weekStart.getDay());
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 42);
    return { weekStart: weekStart, weekEnd: weekEnd };
  }

  async convertMinutesToDecimalHours(minutes: number) {
    const decimalHours = minutes / 60;
    return Math.round(decimalHours * 10) / 10;
  }

  async checkDatetimeInToday(datetime: Date): Promise<number> {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (datetime < today) {
      return -1;
    } else if (datetime >= today && datetime < tomorrow) {
      return 0;
    } else {
      return 1;
    }
  }

  async getTodayMidnight(): Promise<Date> {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  async getTomorrowMidnight(): Promise<Date> {
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }

  async getYesterdayMidnight(): Promise<Date> {
    const yesterday = new Date();
    yesterday.setHours(0, 0, 0, 0);
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  }

  async getNextDayMidnight(date: Date): Promise<Date> {
    const nextDay = new Date(date);
    nextDay.setHours(0, 0, 0, 0);
    nextDay.setDate(nextDay.getDate() + 1);
    return nextDay;
  }

  async getDateAfter6Month(): Promise<Date> {
    const dateAfter6Month = new Date();
    dateAfter6Month.setHours(0, 0, 0, 0);
    dateAfter6Month.setMonth(dateAfter6Month.getMonth() + 6);
    return dateAfter6Month;
  }
}
